/**
 * Лёгкий клиентский логгер с уровнями.
 *
 * Зачем: в проде голый console.log шумит в DevTools пользователя и может утечь
 * данными (пароли/токены попадали в console.log). `debug`/`info` идут ТОЛЬКО
 * при явном флаге сборки REACT_APP_DEBUG_LOG=true (в проде и тестах молчат);
 * `warn`/`error` идут всегда — это диагностика инцидентов, а тесты их мокают
 * (jest.spyOn(console,'error')), поэтому НЕ глушим по NODE_ENV.
 *
 * Единая точка: если позже подключим отправку ошибок на сервер (Sentry и т.п.),
 * менять только здесь.
 */
const debugEnabled = process.env.REACT_APP_DEBUG_LOG === 'true';

/**
 * Санитайзер аргументов: axios AxiosError/AxiosResponse несут config.headers с
 * `Authorization: Bearer <token>`. Голый console.error(axiosError) раскрывает
 * заголовки в DevTools = утечка access/refresh-токена (Codex). Логируем только
 * безопасную проекцию (сообщение/метод/url/статус), без headers и тела.
 */
function sanitize(arg) {
  if (!arg || typeof arg !== 'object') return arg;
  if (arg.isAxiosError) {
    return {
      axiosError: true,
      message: arg.message,
      method: arg.config && arg.config.method,
      url: arg.config && arg.config.url,
      status: arg.response && arg.response.status,
    };
  }
  // AxiosResponse: есть status + headers + config + data
  if (arg.config && arg.headers && arg.status !== undefined && 'data' in arg) {
    return {
      axiosResponse: true,
      status: arg.status,
      url: arg.config && arg.config.url,
    };
  }
  return arg;
}

const emit = (sink, args) => sink(...args.map(sanitize));

export const logger = {
  debug: (...args) => {
    if (debugEnabled) emit(console.debug, args);
  },
  info: (...args) => {
    if (debugEnabled) emit(console.info, args);
  },
  warn: (...args) => {
    emit(console.warn, args);
  },
  error: (...args) => {
    emit(console.error, args);
  },
};

export default logger;
